import axios from '@/api';

export default {
  async fetchCountries({ commit }, { countryCode = 'TR' }) {
    const { items } = await axios
      .get('lookup/countries', {
        params: {
          _filter: `countryCode.toLower()=="${countryCode}".toLower()`,
          _limit: -1,
        },
      })
      .then(response => response.data);

    commit('setCountries', { items });

    return items;
  },
  async fetchCities({ commit }, { countryCode = 'TR' }) {
    const { items } = await axios
      .get('lookup/cities', {
        params: {
          _filter: `countryCode.toLower()=="${countryCode}".toLower()`,
          _limit: -1,
        },
      })
      .then(response => response.data);

    commit('setCities', { items });

    return items;
  },
  async fetchCounties({ commit }, { cityId = null }) {
    const { items } = await axios
      .get('lookup/counties', {
        params: { _filter: `cityId=="${cityId}"`, _limit: -1 },
      })
      .then(response => response.data);

    commit('setCounties', { items });

    return items;
  },
  async fetchDistricts({ commit }, { countyId = null }) {
    const { items } = await axios
      .get('lookup/districts', {
        params: { _filter: `countyId=="${countyId}"`, _limit: -1 },
      })
      .then(response => response.data);

    commit('setDistricts', { items });

    return items;
  },
};
